import axios from 'axios';

const log = require("loglevel").getLogger("IntegrationService");
log.setLevel("error");

export const getConnectUrl = ({ vendor, redirectUri }) => {
	return axios.get(`${process.env.REACT_APP_HOST_URL}/integrations/crms/get-connect-url`, {
		params: { vendor, redirectUri }
	})
		.then(async response => {
			const res = response.data.data;
			log.debug("IntegrationService -> getConnectUrl -> return");
			return res;
		})
		.catch(response => {
			log.debug("IntegrationService -> getConnectUrl -> error: ");
			log.debug(response);
			return null;
		});
};

export const getMyconnection = () => {
	return axios.get(`${process.env.REACT_APP_HOST_URL}/integrations/crms/my-connection`)
		.then(async response => {
			const res = response.data.data;
			log.debug("IntegrationService -> getMyconnection -> return");
			return res;
		})
		.catch(response => {
			log.debug("IntegrationService -> getMyconnection -> error: ");
			log.debug(response);
			return null;
		});
};

export const disconnectMyconnection = () => {
	return axios.post(`${process.env.REACT_APP_HOST_URL}/integrations/crms/disconnect-my-connection`)
		.then(async response => {
			const res = response.data;
			log.debug("IntegrationService -> disconnectMyconnection -> return");
			return res;
		})
		.catch(response => {
			log.debug("IntegrationService -> disconnectMyconnection -> error: ");
			log.debug(response);
			return null;
		});
};

export const connectToAce = ({
	connectionId,
	vendor,
	credential,
}) => {
	return axios.post(`${process.env.REACT_APP_HOST_URL}/integrations/aces/connect`, {
		connectionId,
		vendor,
		credential,
	})
		.then(async response => {
			const res = response.data;
			log.debug("IntegrationService -> connectToAce -> return");
			return res;
		})
		.catch(response => {
			log.debug("IntegrationService -> connectToAce -> error: ");
			log.debug(response);
			return null;
		});
};

export const getCRMProperties = ({ vendor, objectType }) => {
	return axios.get(`${process.env.REACT_APP_HOST_URL}/integrations/crms/properties`, {
		params: { vendor, objectType }
	})
		.then(async response => {
			const res = response.data;
			log.debug("IntegrationService -> getCRMProperties -> return");
			return res;
		})
		.catch(response => {
			log.debug("IntegrationService -> getCRMProperties -> error: ");
			log.debug(response);
			return null;
		});
};

export const saveFieldMappings = ({ vendor, body }) => {
	return axios.post(`${process.env.REACT_APP_HOST_URL}/integrations/crms/field-mappings`, body, {
		params: { vendor }
	})
		.then(async response => {
			const res = response.data;
			log.debug("IntegrationService -> saveFieldMappings -> return");
			return res;
		})
		.catch(response => {
			log.debug("IntegrationService -> saveFieldMappings -> error: ");
			log.debug(response);
			return null;
		});
};

export const getFieldMappingsList = ({ vendor, crm_id }) => {
	return axios.get(`${process.env.REACT_APP_HOST_URL}/integrations/crms/field-mappings`, {
		params: { vendor, crm_id }
	})
		.then(async response => {
			const res = response.data;
			log.debug("IntegrationService -> getFieldMappingsList -> return");
			return res;
		})
		.catch(response => {
			log.debug("IntegrationService -> getFieldMappingsList -> error: ");
			log.debug(response);
			return null;
		});
};

export const getFieldMappingDetail = ({ id }) => {
	return axios.get(`${process.env.REACT_APP_HOST_URL}/integrations/crms/field-mappings/${id}`)
		.then(async response => {
			const res = response.data;
			log.debug("IntegrationService -> getFieldMappingDetail -> return");
			return res;
		})
		.catch(response => {
			log.debug("IntegrationService -> getFieldMappingDetail -> error: ");
			log.debug(response);
			return null;
		});
};

export const updateFieldMappings = ({ id, body }) => {
	return axios.put(`${process.env.REACT_APP_HOST_URL}/integrations/crms/field-mappings/${id}`, body)
		.then(async response => {
			const res = response.data;
			log.debug("IntegrationService -> updateFieldMappings -> return");
			return res;
		})
		.catch(response => {
			log.debug("IntegrationService -> updateFieldMappings -> error: ");
			log.debug(response);
			return null;
		});
};

export const deleteFieldMapping = ({ id }) => {
	return axios.delete(`${process.env.REACT_APP_HOST_URL}/integrations/crms/field-mappings/${id}`)
		.then(async response => {
			const res = response.data;
			log.debug("IntegrationService -> deleteFieldMapping -> return");
			return res;
		})
		.catch(response => {
			log.debug("IntegrationService -> deleteFieldMapping -> error: ");
			log.debug(response);
			return null;
		});
};

export const makeDefaultFieldMapping = ({ id }) => {
	return axios.put(`${process.env.REACT_APP_HOST_URL}/integrations/crms/field-mappings/${id}`, {
		is_default: true
	})
		.then(async response => {
			const res = response.data;
			log.debug("IntegrationService -> makeDefaultFieldMapping -> return");
			return res;
		})
		.catch(response => {
			log.debug("IntegrationService -> makeDefaultFieldMapping -> error: ");
			log.debug(response);
			return null;
		});
};

export const duplicateFieldMapping = ({ id, name }) => {
	return axios.post(`${process.env.REACT_APP_HOST_URL}/integrations/crms/field-mappings/${id}/duplicate`, {
		name
	})
		.then(async response => {
			const res = response.data;
			log.debug("IntegrationService -> duplicateFieldMapping -> return");
			return res;
		})
		.catch(response => {
			log.debug("IntegrationService -> duplicateFieldMapping -> error: ");
			log.debug(response);
			return null;
		});
};

export const getSolutions = ({ vendor }) => {
	return axios.get(`${process.env.REACT_APP_HOST_URL}/integrations/aces/solutions`, {
		params: { vendor }
	})
		.then(async response => {
			const res = response.data;
			log.debug("IntegrationService -> getSolutions -> return");
			return res;
		})
		.catch(response => {
			log.debug("IntegrationService -> getSolutions -> error: ");
			log.debug(response);
			return null;
		});
};
